export default "__VITE_ASSET__BwqMbtg4__"